var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.states.loadingResults || _vm.states.errorResults
      ? _c("div", { staticClass: "placeholder loading-skeleton-1" }, [
          _vm.states.errorResults
            ? _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c("v-icon", { attrs: { color: "error", "x-large": "" } }, [
                      _vm._v("error"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "headline text-xs-center" }, [
                  _vm._v("\n        Sorry, we couldn't load the data. "),
                  _c("br"),
                  _vm._v(
                    "\n        Please contact Hatfield for assistance.\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [_c("ContactSupport", { staticClass: "mt-3" })],
                  1
                ),
              ])
            : _vm.states.loadingResults
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-icon",
                      { attrs: { color: "success", "x-large": "" } },
                      [_vm._v("view_comfy")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "headline loading-dots" }, [
                  _vm._v("\n        Loading\n        "),
                  _c("span", [_vm._v(".")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(".")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(".")]),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }